import React, { useContext } from 'react';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '../AddReview.css' or its corre... Remove this comment to see the full error message
import s from '../AddReview.css';
import withStyles from '../../../core/isomorphic-style-loader/withStyles';
import WouldYouRecommendCollection from '../steps/WouldYouRecommendCollection';
import AskIfHaveGoogleAccount from '../steps/AskIfHaveGoogleAccount';
import ThankYou from '../steps/ThankYou';
import LeaveReviewOnSolv from '../steps/ReviewOnSolvCollector';
import { ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE } from '../../../constants/index';
import { ReviewContext } from '~/routes/addReview/context';

const RecommendToGoogle = () => {
  const context = useContext(ReviewContext)!;
  const {
    booking,
    bookingId,
    error,
    flowState,
    googleUrl,
    handleRatingChange,
    handleHasRecommendedClinicChange,
    hasRecommendedClinic,
    isSubmitting,
    leaveAReview,
    location,
    onStarChange,
    review,
    setFlowState,
    starRating,
    submitReview,
  } = context;

  return (
    <div>
      <WouldYouRecommendCollection
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        handleHasRecommendedClinicChange={handleHasRecommendedClinicChange}
        handleRatingChange={handleRatingChange}
        location={location}
        onStarChange={onStarChange}
        review={review}
        setFlowState={setFlowState}
        starRating={starRating}
        submitReview={submitReview}
      />

      <AskIfHaveGoogleAccount
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        googleUrl={googleUrl}
        handleRatingChange={handleRatingChange}
        hasRecommendedClinic={hasRecommendedClinic}
        isSubmitting={isSubmitting}
        leaveAReview={leaveAReview}
        location={location}
        review={review}
        setFlowState={setFlowState}
        starRating={starRating}
        submitReview={submitReview}
      />

      <LeaveReviewOnSolv
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        flowType={ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE}
        handleRatingChange={handleRatingChange}
        leaveAReview={leaveAReview}
        location={location}
        onStarChange={onStarChange}
        submitReview={submitReview}
      />

      <ThankYou
        booking={booking}
        bookingId={bookingId}
        flowState={flowState}
        starRating={starRating}
      />
    </div>
  );
};

export default withStyles(s)(RecommendToGoogle);
